const indices: { [key: string]: number } = {};

export const generateId = (key: string) =>
    (indices[key] = indices[key] === undefined ? 1 : indices[key] + 1);
export const setMinId = (key: string, minId: number) => (indices[key] = minId);
